<template>
  <div>
    <div class="text-overline--small neutral--text text--darken-1 mb-3">
      {{ $t('fields.account.billing.payment.payment_methods_section') }}
    </div>

    <v-card outlined rounded class="px-3 py-4" height="90">
      <v-skeleton-loader type="heading" width="225" height="24" class="rounded-pill" />
      <v-skeleton-loader type="text" width="180" class="mt-3" />
    </v-card>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class PaymentMethodListSkeleton extends Vue {}
</script>
